module.exports = __webpack_public_path__ + "img/dev01.d8d507fa.jpg";